import options from './component';


export default {
    selector: "dtEmulatorBatteryStatus",
    options
}